var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            staticStyle: { "text-align": "center" },
            attrs: { slot: "header" },
            slot: "header"
          },
          [
            _c("span", [_c("strong", [_vm._v("Groupe Philippe Marraud")])]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [_c("strong", [_vm._v("EASY 2")])])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "loginForm",
                staticClass: "login-form",
                attrs: {
                  model: _vm.loginForm,
                  rules: _vm.loginRules,
                  autocomplete: "off",
                  "label-position": "left",
                  size: "mini"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "id_societe", size: "mini" } },
                  [
                    _c(
                      "span",
                      { staticClass: "svg-container" },
                      [_c("svg-icon", { attrs: { "icon-class": "location" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("listSociete", {
                      key: "id_societe_" + _vm.loginForm.id_societe,
                      attrs: {
                        societe: _vm.selection.societe,
                        "id-societe-selected": _vm.loginForm.id_societe,
                        placeholder: "Société",
                        tabindex: "1"
                      },
                      on: {
                        "update:societe": function($event) {
                          return _vm.$set(_vm.selection, "societe", $event)
                        },
                        "update:idSocieteSelected": function($event) {
                          return _vm.$set(_vm.loginForm, "id_societe", $event)
                        },
                        "update:id-societe-selected": function($event) {
                          return _vm.$set(_vm.loginForm, "id_societe", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "email", size: "mini" } },
                  [
                    _c(
                      "span",
                      { staticClass: "svg-container" },
                      [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      ref: "email",
                      attrs: {
                        placeholder: "Email",
                        name: "email",
                        type: "text",
                        tabindex: "2",
                        autocomplete: "off",
                        size: "mini",
                        readonly: "",
                        onfocus: "this.removeAttribute('readonly');"
                      },
                      model: {
                        value: _vm.loginForm.email,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "email", $$v)
                        },
                        expression: "loginForm.email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "password", size: "mini" } },
                  [
                    _c(
                      "span",
                      { staticClass: "svg-container" },
                      [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      key: _vm.passwordType,
                      ref: "password",
                      attrs: {
                        type: _vm.passwordType,
                        placeholder: "Mot de passe",
                        name: "password",
                        tabindex: "3",
                        autocomplete: "off",
                        size: "mini"
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleLogin($event)
                        }
                      },
                      model: {
                        value: _vm.loginForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "password", $$v)
                        },
                        expression: "loginForm.password"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                      [
                        _c("svg-icon", {
                          attrs: {
                            "icon-class":
                              _vm.passwordType === "password"
                                ? "eye"
                                : "eye-open"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { loading: _vm.loading, type: "primary" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleLogin($event)
                      }
                    }
                  },
                  [_vm._v("Connexion")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-link",
                      {
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              name: "PasswordReminder"
                            })
                          }
                        }
                      },
                      [_c("small", [_vm._v("Mot de passe oublié ?")])]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "versionInfo",
                    staticStyle: { float: "right" }
                  },
                  [
                    _vm._v(
                      "\n          app " +
                        _vm._s(_vm.gitInfo.app.lastTagVersion) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "versionInfo",
                    staticStyle: { float: "left" }
                  },
                  [
                    _vm._v(
                      "\n          api " +
                        _vm._s(_vm.gitInfo.api.lastTagVersion) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }